import PT from 'prop-types';

export const FileType = PT.shape({
	remoteURL: PT.string.isRequired,
	file: PT.shape({
		name: PT.string.isRequired,
		url: PT.string.isRequired,
	}).isRequired,
	selected: PT.oneOf(['remoteURL', 'file']).isRequired,
});
